module.exports = __webpack_public_path__ + "img/cmp_gao.da4f4627.png";